module.exports = __webpack_public_path__ + "img/category.f51a786d.svg";